import { render, staticRenderFns } from "./onePost.vue?vue&type=template&id=30e75a7c&"
import script from "./onePost.vue?vue&type=script&lang=js&"
export * from "./onePost.vue?vue&type=script&lang=js&"
import style0 from "./onePost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports